module.exports = __webpack_public_path__ + "static/media/macbook01.9a0c5529.png";